// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"676":"5229a021","780":"16b96169"}[chunkId] + ".chunk.js";
};